import * as moment from 'moment';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { Constants } from '@config/constants';
import { HttpClient } from '@angular/common/http';
import { catchError, retry } from 'rxjs/operators';
import { IChartFilter, IChartFromApi } from 'app/models';
import { ErrorHandlingService } from '../error-handling/error.handling.service';

@Injectable()
export class ChartService {
  constructor(
    private readonly http: HttpClient,
    private readonly constants: Constants,
    private readonly errorHandlingService: ErrorHandlingService
  ) {}

  getSumCutCrease = ({
    machineId,
    dateRange: { startDate, endDate } = {
      startDate: moment().startOf('day'),
      endDate: moment().endOf('day'),
    },
    graphPeriodType,
    zoneId
  }: IChartFilter): Observable<IChartFromApi[]> =>
    this.http
      .get<IChartFromApi[]>(
        `${
          this.constants.CHART_SUM_CUT_CREASE_ENDPOINT
        }?machineId=${machineId}&from=${moment(startDate).format(
          'YYYY-MM-DDTHH:mm:ss'
        )}&to=${moment(endDate).format(
          'YYYY-MM-DDTHH:mm:ss'
        )}&graphPeriodType=${graphPeriodType}
        &zoneId=${zoneId}`
      )
      .pipe(
        retry(this.constants.HTTP_REQUEST_RETRY_TIMES),
        catchError(this.errorHandlingService.handleHttpError)
      );

  getSumOfJobs = ({
    machineId,
    dateRange: { startDate, endDate } = {
      startDate: moment().startOf('day'),
      endDate: moment().endOf('day'),
    },
    graphPeriodType,
    zoneId
  }: IChartFilter): Observable<IChartFromApi[]> =>
    this.http
      .get<IChartFromApi[]>(
        `${
          this.constants.CHART_SUM_OF_JOBS_ENDPOINT
        }?machineId=${machineId}&from=${moment(startDate).format(
          'YYYY-MM-DDTHH:mm:ss'
        )}&to=${moment(endDate).format(
          'YYYY-MM-DDTHH:mm:ss'
        )}&graphPeriodType=${graphPeriodType}&zoneId=${zoneId}`
      )
      .pipe(
        retry(this.constants.HTTP_REQUEST_RETRY_TIMES),
        catchError(this.errorHandlingService.handleHttpError)
      );
}
